import Lookup from 'src/componentes/select2';

const TipoEvidenciaLookup = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/TipoEvidenciaLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default TipoEvidenciaLookup;
